import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'
import { LearnerMirrorSection } from './parts/LearnerMirrorSection'
import { CoachingMetaSection } from './parts/CoachingMetaSection'
import { AudioResponseList } from './parts/AudioResponseList'
import { PartialDataFallback } from './parts/PartialDataFallback'

interface Props {
  component: ComponentProgressDetailView
}

export function GuideCoachingDetail({ component }: Props) {
  const { t } = useTranslation('coaching')
  const guide = component.guide
  if (!guide) return <PartialDataFallback type="guide" />

  const hasMirrorContent = !!(guide.message || guide.explainQuiz)

  return (
    <div className="space-y-3">
      <LearnerMirrorSection title={t('section.learnerView')}>
        {hasMirrorContent ? (
          <div className="space-y-2">
            {guide.message && (
              <div className="rounded border border-gray-200 bg-white p-2">
                <p className="text-[10px] font-medium uppercase text-gray-500">
                  {t('guide.message.label')}
                </p>
                <p className="mt-1 whitespace-pre-wrap text-xs text-gray-800">{guide.message}</p>
              </div>
            )}
            {guide.explainQuiz && (
              <div className="rounded border border-gray-200 bg-white p-2">
                <p className="text-[10px] font-medium uppercase text-gray-500">
                  {t('guide.explainQuiz.label')}
                </p>
                <div className="mt-1 flex items-center gap-2">
                  {guide.explainQuiz.image && (
                    <img
                      src={guide.explainQuiz.image}
                      alt="explain quiz"
                      className="h-12 w-20 flex-shrink-0 rounded object-cover"
                    />
                  )}
                  <p className="text-xs text-gray-800">
                    {guide.explainQuiz.title ?? t('guide.explainQuiz.label')}
                  </p>
                </div>
              </div>
            )}
          </div>
        ) : (
          <p className="text-xs italic text-gray-500">{t('placeholder.comingSoon')}</p>
        )}
      </LearnerMirrorSection>
      <CoachingMetaSection title={t('section.coachingMeta')}>
        <div className="space-y-2">
          {guide.templateId && (
            <div className="text-xs text-gray-500">
              {t('guide.templatePrefix')}
              {guide.templateId}
            </div>
          )}
          <AudioResponseList
            response1={guide.audioResponse1Url ?? null}
            response2={guide.audioResponse2Url ?? null}
          />
        </div>
      </CoachingMetaSection>
    </div>
  )
}
